export default __webpack_public_path__ + "static/media/simon.e1413e2a.png";